import React from "react";
import styled from "styled-components";

import PlaylistItem from "./playlist-item";
import { Col, Text, Button, Row } from "../../comps";
import { Theme } from "../../theme/theme-provider";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
`;

const Head = styled(Col)`
  width: 90%;
  height: 10%;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_2};
`;

const ListWrapper = styled(Col)`
  margin-top: 8px;
  width: 90%;
  height: 90%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
`;

export default ({ playlists, onSelect }) => {
  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="20px"
          width="90%"
          color={Theme.textColor.light}
          textAlign="left"
        >
          {"choose playlist"}
        </Text>
      </Head>
      <ListWrapper>
        {playlists.map((playlist) => {
          return <PlaylistItem playlist={playlist} onSelect={onSelect} />;
        })}
      </ListWrapper>
    </Wrapper>
  );
};
